import { PatientDetailScreen } from '../features/console';

export function PatientDetailPage() {
  return <PatientDetailScreen />;
}
